import View from "@asantech/common/react/Login/LoginView";
import client from "api/client";

export const LoginView = () => <View title="ANPR" client={client} />;
